import styled from '@emotion/styled';
import {
  Button,
  ButtonWithForwardRef,
  colors,
  DraggableMenu,
  DraggableMenuItem,
  DropdownButton,
  DropdownMenu,
  Popover,
  Stack,
  Typography,
} from '@ui-components/neo.tax';
import { ReactComponent as FilterIcon } from '@ui-components/neo.tax/dist/icons/concept-filtering.svg';
import { ReactComponent as PlusIcon } from '@ui-components/neo.tax/dist/icons/plus.svg';
import { ReactComponent as TrashBin } from '@ui-components/neo.tax/dist/icons/trash-bin-fill.svg';

import { screenMd, ZIndex } from '@neo.tax/shared/utils';

export const StyledDropdownMenu = styled(DropdownMenu)({
  '> span': {
    color: colors.gray[400],
  },
}) as typeof DropdownMenu;

export const StyledColumnDropdownMenu = styled(StyledDropdownMenu)({
  width: 225,
}) as typeof DropdownMenu;

export const StyledOperatorDropdownMenu = styled(StyledDropdownMenu)({
  width: 200,
}) as typeof DropdownMenu;

export const StyledBooleanDropdownMenu = styled(StyledDropdownMenu)({
  width: 100,
}) as typeof DropdownMenu;

export const StyledDropdownButton = styled(DropdownButton)([
  { flex: 1 },
  screenMd({
    '.menu-value': {
      display: 'none',
    },
  }),
]) as typeof DropdownButton;

export const StyledPopover = styled(Popover)({
  padding: '1rem 1.5rem',
  minWidth: '50rem',
  zIndex: ZIndex.MODAL,
});

const iconStyle = { color: colors.gray[400] };

export const StyledFilterIcon = styled(FilterIcon)(iconStyle);

export const StyledAddConditionButton = styled(ButtonWithForwardRef)({ margin: 0 });

export const StyledResetButton = styled(Button)({ margin: 0 });

export const StyledConditionRow = styled(Stack)({
  height: 38,
  paddingLeft: 13,
});

export const StyledTitle = styled(Typography)({
  width: 100,
  // Match the DropdownMenu's L-R spacing (which includes a 1px border).
  padding: '9px calc(1rem + 1px)',
  color: colors.gray[400],
});

export const StyledPopoverTitle = styled(Typography)({
  color: colors.gray[400],
});

export const StyledPopoverTitleSemibold = styled(Typography)({
  color: colors.gray[500],
});

export const StyledPlusIcon = styled(PlusIcon)({
  height: 24,
  width: 24,
  marginTop: -4,
  marginLeft: -2,
});

export const StyledDraggableMenu = styled(DraggableMenu)({
  borderStyle: 'none',
}) as typeof DraggableMenu;

export const StyledDraggableMenuItem = styled(DraggableMenuItem)({
  borderStyle: 'none',
});

// delete button
export const StyledDeleteButton = styled(Button)({ padding: 9, margin: 0 });

export const StyledTrashBin = styled(TrashBin)({ height: 20, width: 20 });
